import React, {useEffect, useRef, useState} from "react";
import { ROOT_URL } from "../../../config/url";
import {
  useList,
  useAction,
  useUnroll,
  useNotification,
  getErrorMessageByKey,
  useProfile,
  useObject
} from "@vokymlak/kabinet-ui";
import axios from "axios";
import {useParams} from "react-router-dom";

function useCows(props) {
  const { isCount, isLocationNull, typeTag, isDropped } = props;
  const { cowLocationUuid } = useParams();

  const getUrlParams = () => {
    let params = null;
    if (cowLocationUuid) {
      params = {
        ...params,
        location: cowLocationUuid,
      };
    }
    if (isLocationNull) {
      params = {
        ...params,
        "no-location": isLocationNull,
      };
    }
    if (typeTag) {
      params = {
        ...params,
        "type": typeTag,
      };
    }
    if (isDropped) {
      params = {
        ...params,
        "dropped": isDropped,
      };
    }
    return params;
  };

  const {
    list: [list, count, setList],
    update: [isUpdateList, setIsUpdateList, updateList],
    page: [pageNumber, setPageNumber, pageLimit, setPageLimit],
    search: [searchQuery, setSearchQuery],
    params: [paramsCows],
    setApiUrlParams,
  } = useList({
    apiUrl: "/api/cows",
    rootUrl: ROOT_URL,
    isPagination: true,
    paginationLimit: 100,
    isSearch: true,
    urlParams: getUrlParams(),
  });

  const { unrolls, isUnroll, changeUnroll, changeAllUnroll } = useUnroll();

  const { setAction } = useAction(["cows"], () => updateList());

  useEffect(() => {
    if (!!list) {
      const listUuid = list.map((i) => i.uuid);
      setAction([...listUuid, "cows"]);
    } else {
      setAction(["cows"]);
    }
  }, [list]);

  const inputSearchText = useRef(null);
  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery]);

  const onChangeSearchText = () => {
    setSearchQuery(inputSearchText.current.value);
  };

  const changePage = (data) => {
    if (pageNumber !== data.currentPage) {
      setPageNumber(data.currentPage);
    }
  };


  useEffect(() => {
    setApiUrlParams({ ...getUrlParams() });
  }, [isCount, cowLocationUuid, isLocationNull, typeTag]);


  // const isPublishedNomenclature = (object) => {
  //   axios
  //     .get("/api/nomenclature/" + object.uuid + "/edit/publish", {
  //       withCredentials: false,
  //       baseURL: ROOT_URL,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + localStorage.getItem("tokenSession"),
  //       },
  //     })
  //     .then(() => {
  //       setIsUpdateList(!isUpdateList);
  //     })
  //     .catch((error) => {
  //       notification(getErrorMessageByKey(error.response.data.error), "red");
  //     });
  // };

  return {
    list,
    count,
    setList,

    pageNumber,
    pageLimit,
    setPageLimit,
    changePage,

    unrolls,
    isUnroll,
    changeUnroll,
    changeAllUnroll,

    inputSearchText,
    onChangeSearchText,
    searchQuery,

    setIsUpdateList,
    isUpdateList,

    paramsCows,
  };
}

export default useCows;
